import * as React from "react";
import { ThemeConstants } from "src/Core/Common/Constants";



export interface IconImageProps {
    height?: number;
    width?: number;
    color?: string;
    disabled?: boolean;
}

export const ResetFilterIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                stroke={props?.color || ThemeConstants.ICON_COLOR}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.5 4.5l-5 5M14.5 9.5l-5-5"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M1.146 1.146A.5.5 0 001 1.5v2a.5.5 0 00.128.334L5.5 8.692V14.5a.5.5 0 00.658.474l3-1A.5.5 0 009.5 13.5V11h-1v2.14l-2 .666V8.5a.5.5 0 00-.128-.334L2 3.308V2h11v1h1V1.5a.5.5 0 00-.5-.5h-12a.5.5 0 00-.354.146z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const SortByIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M11.5 15a.5.5 0 00.5-.5V2.707l3.146 3.147a.5.5 0 00.708-.708l-4-4a.5.5 0 00-.708 0l-4 4a.5.5 0 10.708.708L11 2.707V14.5a.5.5 0 00.5.5zM4.5 1a.5.5 0 01.5.5v11.793l3.146-3.147a.5.5 0 01.708.708l-4 4a.5.5 0 01-.708 0l-4-4a.5.5 0 01.708-.708L4 13.293V1.5a.5.5 0 01.5-.5z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const MarkAsNotSpamIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                clipPath="url(#clip0_16_99)"
                clipRule="evenodd"
            >
                <path d="M.586 2.586A2 2 0 012 2h12a2 2 0 012 2v4.5a.5.5 0 01-1 0V5.383l-7 4.2-1.326-.795-5.64 3.471A1 1 0 002 13h5.5a.5.5 0 010 1H2a2 2 0 01-2-1.99V4a2 2 0 01.586-1.414zM1 11.105l4.708-2.897L1 5.383v5.722zM1 4v.217l7 4.2 7-4.2V4a1 1 0 00-1-1H2a1 1 0 00-1 1z"></path>
                <path d="M13.84 9.266a3.5 3.5 0 11-2.68 6.467 3.5 3.5 0 012.68-6.467zm-1.591.746a2.5 2.5 0 00-1.835 3.867l3.465-3.465a2.5 2.5 0 00-1.63-.402zm2.337 1.11l-3.464 3.464a2.499 2.499 0 003.865-1.835 2.5 2.5 0 00-.401-1.63z"></path>
            </g>
            <defs>
                <clipPath id="clip0_16_99">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const ForwardIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M9.402 5.013a.144.144 0 00-.202.134V6.3a.5.5 0 01-.5.5c-.667 0-2.013.005-3.3.822-.984.624-1.99 1.76-2.595 3.876C3.825 10.515 4.99 9.982 6.01 9.7a8.74 8.74 0 011.921-.306 7.409 7.409 0 01.798.008h.013l.005.001h.001L8.7 9.9l.05-.498a.5.5 0 01.45.498v1.153c0 .108.11.176.202.134l3.984-2.933a.493.493 0 01.042-.028.147.147 0 000-.252.496.496 0 01-.042-.028L9.402 5.013zM8.2 10.386c-.068 0-.143.003-.223.006a7.745 7.745 0 00-1.7.271c-1.326.368-2.896 1.202-3.94 3.08a.5.5 0 01-.933-.305c.464-3.71 1.886-5.662 3.46-6.66 1.245-.79 2.527-.942 3.336-.971v-.66a1.144 1.144 0 011.767-.96l3.994 2.94a1.147 1.147 0 010 1.946l-3.994 2.94a1.144 1.144 0 01-1.767-.96v-.667z"
            ></path>
        </svg>
    );
};

export const CancelTransferIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M1 8a7 7 0 1014 0A7 7 0 001 8zm2.99 4.63l5.239-5.24.622-.622 2.778-2.779a6.125 6.125 0 01-8.64 8.64zm-.62-.62a6.125 6.125 0 018.64-8.64L9.047 6.337l-.79.789L6.79 8.593 3.37 12.01zm4.886-4.885L7.125 8.256l.566-.565.565-.566z"
            ></path>
            <path
                stroke={props?.color || ThemeConstants.ICON_COLOR}
                strokeWidth="0.3"
                d="M8.256 7.125L6.79 8.593 3.37 12.01a6.125 6.125 0 018.64-8.64L9.046 6.336l-.79.789zm0 0l-.565.566-.566.565 1.131-1.131zm-.256 7a6.101 6.101 0 01-4.01-1.496L9.228 7.39l.622-.622 2.778-2.779A6.125 6.125 0 018 14.125zM8 15A7 7 0 118 1a7 7 0 010 14z"
            ></path>
        </svg>
    );
};

export const ResendAccessLinkIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "19"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 19 16"
        >
            <path
                fill={ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M.586.586A2 2 0 012 0h12a2 2 0 012 2v4.5a.5.5 0 01-1 0V3.383l-7 4.2-1.326-.795-5.64 3.471A1 1 0 002 11h5.5a.5.5 0 010 1H2a2 2 0 01-2-1.99V2A2 2 0 01.586.586zM1 9.105l4.708-2.897L1 3.383v5.722zM1 2v.217l7 4.2 7-4.2V2a1 1 0 00-1-1H2a1 1 0 00-1 1z"
                clipRule="evenodd"
            ></path>
            <path
                fill={ThemeConstants.ICON_COLOR}
                d="M15.56 10.917h2.294c.123 0 .191.144.112.239l-1.147 1.376a.146.146 0 01-.224 0l-1.146-1.376a.146.146 0 01.112-.24zM9.146 12.083h2.293a.146.146 0 00.112-.239l-1.146-1.376a.146.146 0 00-.224 0l-1.147 1.376a.146.146 0 00.112.24z"
            ></path>
            <path
                fill={ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M13.5 8.583c-.905 0-1.714.413-2.25 1.061a.292.292 0 11-.449-.371 3.5 3.5 0 016.15 1.644h-.593A2.917 2.917 0 0013.5 8.583zm-2.857 3.5a2.917 2.917 0 005.106 1.273.291.291 0 11.45.371 3.5 3.5 0 01-6.15-1.644h.594z"
                clipRule="evenodd"
            ></path>
            <path
                stroke={ThemeConstants.ICON_COLOR}
                strokeLinecap="round"
                strokeWidth="0.25"
                d="M15.56 10.917h2.294c.123 0 .191.144.112.239l-1.147 1.376a.146.146 0 01-.224 0l-1.146-1.376a.146.146 0 01.112-.24zM9.146 12.083h2.293a.146.146 0 00.112-.239l-1.146-1.376a.146.146 0 00-.224 0l-1.147 1.376a.146.146 0 00.112.24z"
            ></path>
            <path
                fillRule="evenodd"
                stroke={ThemeConstants.ICON_COLOR}
                strokeLinecap="round"
                strokeWidth="0.25"
                d="M13.5 8.583c-.905 0-1.714.413-2.25 1.061a.292.292 0 11-.449-.371 3.5 3.5 0 016.15 1.644h-.593A2.917 2.917 0 0013.5 8.583zm-2.857 3.5a2.917 2.917 0 005.106 1.273.291.291 0 11.45.371 3.5 3.5 0 01-6.15-1.644h.594z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const MoveToIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M.5 3l.04.87a1.99 1.99 0 00-.342 1.311l.637 7A2 2 0 002.826 14h10.348a2 2 0 001.991-1.819l.637-7A2 2 0 0013.81 3H9.828a2 2 0 01-1.414-.586l-.828-.828A2 2 0 006.172 1H2.5a2 2 0 00-2 2zm.694 2.09A1 1 0 012.19 4h11.62a1 1 0 01.996 1.09l-.636 7a1 1 0 01-.996.91H2.826a1 1 0 01-.995-.91l-.637-7zM6.172 2a1 1 0 01.707.293L7.586 3H2.19c-.24 0-.47.042-.684.12L1.5 2.98A1 1 0 012.5 2h3.672z"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                stroke={ThemeConstants.ICON_COLOR}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
                d="M4.5 8.5a.25.25 0 01.25-.25h5.896L9.073 6.677a.25.25 0 01.354-.354l2 2a.25.25 0 010 .354l-2 2a.25.25 0 01-.354-.354l1.573-1.573H4.75a.25.25 0 01-.25-.25z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const ReplyIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M6.598 5.013a.144.144 0 01.202.134V6.3a.5.5 0 00.5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.741 8.741 0 00-1.921-.306 7.403 7.403 0 00-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 00-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.501.501 0 00-.042-.028.147.147 0 010-.252.501.501 0 00.042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.201 3.94 3.08a.5.5 0 00.933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 00-1.767-.96l-3.994 2.94a1.147 1.147 0 000 1.946l3.994 2.94a1.144 1.144 0 001.767-.96v-.667z"
            ></path>
        </svg>
    );
};

export const RefreshIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M13 8a5 5 0 10-2.914 4.546.5.5 0 01.417.908A6 6 0 1114 8h-1z"
                clipRule="evenodd"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M11.534 8h3.932a.25.25 0 01.192.41l-1.966 2.36a.25.25 0 01-.384 0l-1.966-2.36a.25.25 0 01.192-.41z"
            ></path>
        </svg>
    );
};

export const DeleteIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zM8 5.5a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zM11 6a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 01-1-1V2a1 1 0 011-1H6a1 1 0 011-1h2a1 1 0 011 1h3.5a1 1 0 011 1v1zM4.118 4L4 4.059V13a1 1 0 001 1h6a1 1 0 001-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const ReplyAllIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "17"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 17 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M8.098 5.013a.144.144 0 01.202.134V6.3a.5.5 0 00.5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 00-1.921-.306 7.404 7.404 0 00-.798.008h-.013l-.005.001h-.001L8.8 9.9l-.05-.498a.5.5 0 00-.45.498v1.153c0 .108-.11.176-.202.134L4.114 8.254a.498.498 0 00-.042-.028.147.147 0 010-.252.495.495 0 00.042-.028l3.984-2.933zM9.3 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 00.933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 00-1.767-.96l-3.994 2.94a1.147 1.147 0 000 1.946l3.994 2.94a1.144 1.144 0 001.767-.96v-.667z"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M5.232 4.293a.5.5 0 00-.7-.106L.54 7.127a1.147 1.147 0 000 1.946l3.994 2.94a.5.5 0 10.593-.805L1.114 8.254a.503.503 0 00-.042-.028.147.147 0 010-.252.5.5 0 00.042-.028l4.012-2.954a.5.5 0 00.106-.699z"
            ></path>
        </svg>
    );
};

export const FilterIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M1.5 1.5A.5.5 0 012 1h12a.5.5 0 01.5.5v2a.5.5 0 01-.128.334L10 8.692V13.5a.5.5 0 01-.342.474l-3 1A.5.5 0 016 14.5V8.692L1.628 3.834A.5.5 0 011.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 017 8.5v5.306l2-.666V8.5a.5.5 0 01.128-.334L13.5 3.308V2h-11z"
            ></path>
        </svg>
    );
};

export const DropOffIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M2.95.4a1 1 0 01.8-.4h8.5a1 1 0 01.8.4l2.85 3.8a.5.5 0 01.1.3V15a1 1 0 01-1 1H1a1 1 0 01-1-1V4.5a.5.5 0 01.1-.3L2.95.4zM7.5 1H3.75L1.5 4h6V1zm1 0v3h6l-2.25-3H8.5zM15 5H1v10h14V5z"
            ></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                stroke={props?.color || ThemeConstants.ICON_COLOR}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
                d="M7.823 12.177a.25.25 0 00.354 0l1.5-1.5a.25.25 0 00-.354-.354L8.25 11.396V7a.25.25 0 00-.5 0v4.396l-1.073-1.073a.25.25 0 00-.354.354l1.5 1.5z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const SendReminderIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g fill={props?.color || ThemeConstants.ICON_COLOR}
                clipPath="url(#clip0_5_153)">
                <path d="M10.854 8.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.501.501 0 01.708-.708L7.5 10.793l2.646-2.647a.499.499 0 01.708 0z"></path>
                <path d="M3.5 0a.5.5 0 01.5.5V1h8V.5a.5.5 0 011 0V1h1a2 2 0 012 2v11a2 2 0 01-2 2H2a2 2 0 01-2-2V3a2 2 0 012-2h1V.5a.5.5 0 01.5-.5zM2 2a1 1 0 00-1 1v11a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1H2z"></path>
                <path d="M2.5 4a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V4z"></path>
            </g>
            <defs>
                <clipPath id="clip0_5_153">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const ChangeRetentionPeriodIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g fill={props?.color || ThemeConstants.ICON_COLOR}
                clipPath="url(#clip0_5_79)">
                <path d="M8.515 1.019A7.001 7.001 0 008 1V0a8 8 0 01.589.022l-.074.997zm2.004.45a7 7 0 00-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.017 7.017 0 00-.439-.27l.493-.87c.342.194.67.412.979.654l-.615.789a7.005 7.005 0 00-.418-.302v-.001zm1.834 1.79a6.994 6.994 0 00-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.052 7.052 0 00-.214-.468l.893-.45c.177.351.327.715.45 1.088l-.95.313a6.98 6.98 0 00-.179-.483zm.53 2.507a6.991 6.991 0 00-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025h-.001zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123c-.048.39-.125.776-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.104 8.104 0 01-.401.432l-.707-.707z"></path>
                <path d="M8 1a7 7 0 104.95 11.95l.707.707A8.001 8.001 0 118 0v1z"></path>
                <path d="M7.5 3a.5.5 0 01.5.5v5.21l3.248 1.856a.5.5 0 01-.496.868l-3.5-2A.5.5 0 017 9V3.5a.5.5 0 01.5-.5z"></path>
            </g>
            <defs>
                <clipPath id="clip0_5_79">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const ManageColumnsIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M0 1.5A1.5 1.5 0 011.5 0h13A1.5 1.5 0 0116 1.5v13a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 14.5v-13zM1.5 1a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H5V1H1.5zM10 15V1H6v14h4zm1 0h3.5a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5H11v14z"
            ></path>
        </svg>
    );
};

export const ShareIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g >
                <path
                    fill={props?.color || ThemeConstants.ICON_COLOR}
                    d="M13.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 2.5a2.5 2.5 0 11.603 1.628l-6.718 3.12c.154.49.154 1.015 0 1.504l6.718 3.12a2.5 2.5 0 11-.488.876l-6.718-3.12a2.5 2.5 0 110-3.256l6.718-3.12A2.498 2.498 0 0111 2.5zm-8.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11 5.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
                ></path>
            </g>

        </svg>
    );
};

export const DownloadIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props?.color ?? ThemeConstants.ICON_COLOR}
                d="M.5 9.9a.5.5 0 01.5.5v2.5a1 1 0 001 1h12a1 1 0 001-1v-2.5a.5.5 0 011 0v2.5a2 2 0 01-2 2H2a2 2 0 01-2-2v-2.5a.5.5 0 01.5-.5z"
            ></path>
            <path
                fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props?.color ?? ThemeConstants.ICON_COLOR}
                d="M7.646 11.854a.5.5 0 00.708 0l3-3a.5.5 0 00-.708-.708L8.5 10.293V1.5a.5.5 0 10-1 0v8.793L5.354 8.146a.5.5 0 10-.708.708l3 3z"
            ></path>
        </svg>
    );
};

export const LockIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                d="M8 1a2 2 0 012 2v4H6V3a2 2 0 012-2zm3 6V3a3 3 0 00-6 0v4a2 2 0 00-2 2v5a2 2 0 002 2h6a2 2 0 002-2V9a2 2 0 00-2-2zM5 8h6a1 1 0 011 1v5a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1z"
            ></path>
        </svg>
    );
};

export const UnLockIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                d="M11 1a2 2 0 00-2 2v4a2 2 0 012 2v5a2 2 0 01-2 2H3a2 2 0 01-2-2V9a2 2 0 012-2h5V3a3 3 0 016 0v4a.5.5 0 01-1 0V3a2 2 0 00-2-2zM3 8a1 1 0 00-1 1v5a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1H3z"
            ></path>
        </svg>
    );
};

export const EditIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width || "16"}
            height={props?.height || "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                d="M12.146.146a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-10 10a.5.5 0 01-.168.11l-5 2a.5.5 0 01-.65-.65l2-5a.5.5 0 01.11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 01.5.5v.5h.5a.5.5 0 01.5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 015 12.5V12h-.5a.5.5 0 01-.5-.5V11h-.5a.5.5 0 01-.468-.325z"
            ></path>
        </svg>
    );
};

export const CopyIcon: React.FC<IconImageProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill={props.color ?? ThemeConstants.ICON_COLOR}
                d="M13 0H6a2 2 0 00-2 2 2 2 0 00-2 2v10a2 2 0 002 2h7a2 2 0 002-2 2 2 0 002-2V2a2 2 0 00-2-2zm0 13V4a2 2 0 00-2-2H5a1 1 0 011-1h7a1 1 0 011 1v10a1 1 0 01-1 1zM3 4a1 1 0 011-1h7a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V4z"
            ></path>

            <defs>
                <clipPath id="clip0_2203_448664">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};
export const MessageOptionsAuthenticationIcon: React.FC<IconImageProps> = props => (
    <svg width={props.width} height={props.height}>
        <svg viewBox="0 0 480.554 480.554" width={props.width} height={props.height}>
            <path
                fill={props.color || "#0973ba"}
                d="M391.452 237.064s89.102-35.522 89.102-122.595c0-11.716-2.266-22.902-6.376-33.149l-83.794-27.727-81.658 27.727c-4.11 10.247-6.376 21.434-6.376 33.149 0 89.102 89.102 122.595 89.102 122.595zm-.166-165.936 70.078 23.188a72.556 72.556 0 0 1 2.826 20.154c0 30.915-12.887 58.183-38.305 81.047-13.402 12.056-27.047 19.795-34.589 23.588l-.011-.006V71.128z"
                className="color000 svgShape"
            />
            <path
                fill={props.color || "#0973ba"}
                d="M421.683 382.179c0 2.356-.662 4.506-1.641 6.488L314.513 283.129l38.291-38.29c-6.998-4.521-14.664-10.1-22.375-16.853-.533-.467-1.05-.942-1.574-1.413l-98.479 98.48c-2.463 2.463-6.749 2.463-9.214 0L57.337 161.222h227.518c-3.225-9.611-5.42-19.583-6.566-29.854H44.779C20.087 131.368 0 151.455 0 176.148v206.03c0 24.693 20.087 44.781 44.779 44.781h361.976c24.694 0 44.781-20.088 44.781-44.781V228.043c-10.565 9.232-21.118 16.36-29.854 21.536v132.6zm-390.198 6.488c-.97-1.983-1.631-4.132-1.631-6.488v-206.03c0-.058.029-.101.029-.159l107.141 107.14L31.485 388.667zm33.776 8.439 92.871-92.869 41.922 41.924c6.874 6.872 16.007 10.654 25.714 10.654 9.71 0 18.841-3.782 25.715-10.654l41.924-41.924 92.86 92.869H65.261z"
                className="color000 svgShape"
            />
        </svg>
    </svg>
);

export const MessageOptionsRetentionIcon: React.FC<IconImageProps> = props => (
    <svg
        id="SvgjsSvg1037"
        width={props.width}
        height={props.height}
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs id="SvgjsDefs1038"></defs>
        <g id="SvgjsG1039">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                enableBackground="new 0 0 60 60"
                viewBox="0 0 60 60"
                width={props.width}
                height={props.height}
            >
                <path
                    d="M59,52.5h-1v-2.36c0-3.534-1.845-6.748-4.827-8.64C56.155,39.608,58,36.395,58,32.86V30.5h1c0.553,0,1-0.447,1-1
		s-0.447-1-1-1h-1h-1H43h-1h-1c-0.553,0-1,0.447-1,1s0.447,1,1,1h1v2.36c0,3.534,1.845,6.748,4.827,8.64
		C43.845,43.392,42,46.605,42,50.14v2.36h-2c-0.553,0-1,0.447-1,1s0.447,1,1,1h2h14h2h1c0.553,0,1-0.447,1-1S59.553,52.5,59,52.5z
		 M44,32.86V30.5h12v2.36c0,3.319-2.033,6.298-5.197,7.64h-1.605C46.033,39.158,44,36.18,44,32.86z M44,52.5v-2.36
		c0-3.319,2.033-6.298,5.197-7.64h1.605C53.967,43.842,56,46.82,56,50.14v2.36H44z"
                    fill={props.color || "#0973ba"}
                    className="color000 svgShape"
                ></path>
                <path
                    d="M37,44.5H3.879c4.548-3.604,14.801-11.781,20.069-16.403l1.421,1.255c1.002,0.894,2.317,1.341,3.633,1.341
		c1.313,0,2.626-0.446,3.625-1.337L56,8.718V24.5c0,0.553,0.447,1,1,1s1-0.447,1-1v-18c0-0.008-0.004-0.015-0.005-0.023
		c-0.003-0.111-0.019-0.222-0.06-0.33c-0.003-0.007-0.008-0.012-0.011-0.019c-0.011-0.027-0.029-0.049-0.042-0.075
		c-0.041-0.081-0.089-0.155-0.148-0.22c-0.026-0.029-0.054-0.052-0.083-0.078c-0.062-0.054-0.129-0.099-0.202-0.136
		c-0.033-0.017-0.063-0.035-0.098-0.048C57.24,5.529,57.124,5.5,57,5.5H1c-0.124,0-0.24,0.029-0.351,0.071
		C0.614,5.584,0.584,5.602,0.551,5.619C0.477,5.656,0.411,5.701,0.348,5.755C0.319,5.781,0.292,5.804,0.266,5.833
		c-0.06,0.065-0.108,0.14-0.149,0.221C0.104,6.079,0.086,6.101,0.075,6.128C0.072,6.134,0.067,6.14,0.064,6.146
		c-0.041,0.108-0.057,0.219-0.06,0.33C0.004,6.485,0,6.492,0,6.5v39c0,0.003,0.002,0.006,0.002,0.009
		c0.001,0.107,0.017,0.214,0.053,0.319c0.004,0.012,0.013,0.022,0.018,0.034c0.013,0.034,0.034,0.063,0.051,0.095
		c0.039,0.074,0.082,0.142,0.137,0.203c0.028,0.031,0.056,0.058,0.088,0.085c0.06,0.053,0.126,0.096,0.197,0.133
		c0.034,0.018,0.066,0.037,0.102,0.051C0.759,46.471,0.876,46.5,1,46.5h36c0.553,0,1-0.447,1-1S37.553,44.5,37,44.5z M2,43.437
		V8.718l20.437,18.046C16.881,31.617,6.086,40.204,2,43.437z M54.356,7.5L31.299,27.86c-1.267,1.132-3.331,1.132-4.602-0.004
		l-1.979-1.747c-0.006-0.007-0.007-0.015-0.013-0.021c-0.022-0.025-0.053-0.035-0.077-0.058L3.644,7.5H54.356z"
                    fill={props.color || "#0973ba"}
                    className="color000 svgShape"
                ></path>
            </svg>
        </g>
    </svg>
);

export const MessageOptionsTaxYearIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 16}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 16 16"
    >
        <g fill={props.color || "#fff"} clipPath="url(#clip0_3213_11951)">
            <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.501.501 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0"></path>
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"></path>
            <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"></path>
        </g>
        <defs>
            <clipPath id="clip0_3213_11951">
                <path fill={props.color || "#fff"} d="M0 0h16v16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const DropOffOFFIcon: React.FC<IconImageProps> = props => (
    <svg width={20} height={20} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M44 35V9H4v28h22"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: `${ThemeConstants.ICON_COLOR}`,
                paintOrder: "stroke",
            }}
        />
        <circle
            cx={35.057}
            cy={35}
            r={5}
            style={{
                fill: "#fff",
                paintOrder: "fill",
                stroke: `${"#ad0404"}`,
                strokeWidth: 10,
            }}
        />
        <path
            d="m39.529 30.701-9.346 9.346"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: "#fafafa",
            }}
        />
        <path
            d="m4 9 20 13L44 9"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: `${ThemeConstants.ICON_COLOR}`,
            }}
        />
    </svg>
);
export const DropOffONIcon: React.FC<IconImageProps> = props => (
    <svg viewBox="0 0 48 48" width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M44 35V9H4v28h22"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: `${ThemeConstants.ICON_COLOR}`,
                paintOrder: "stroke",
            }}
        />
        <circle
            cx={35.057}
            cy={35}
            r={5}
            style={{
                fill: "#fff",
                paintOrder: "fill",
                strokeWidth: 10,
                stroke: `${"#88c656"}`,
            }}
        />
        <path
            d="m41.484 31.736-8.139 9.173-4.718-3.313"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: "#fafafa",
            }}
        />
        <path
            d="m4 9 20 13L44 9"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                stroke: `${ThemeConstants.ICON_COLOR}`,
            }}
        />
    </svg>
);

export const BlockUserIcon: React.FC<IconImageProps> = props => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M327.478 475.846c-15.149 26.116 73.945-171.312 72.195-173.062-29.761-29.762-66.236-50.37-106.007-60.423 42.048-20.964 71.004-64.411 71.004-114.5C364.669 57.358 307.311 0 236.809 0c-70.502 0-127.861 57.358-127.861 127.86 0 50.089 28.957 93.536 71.004 114.5-39.771 10.053-76.245 30.661-106.007 60.423-43.502 43.502-67.46 101.341-67.46 162.864 0 5.633 4.566 10.199 10.199 10.199h310.794Z"
            style={{
                strokeWidth: 50,
                strokeMiterlimit: 1,
                fill: `${"#05396b"}`,
            }}
        />
        <ellipse
            style={{
                stroke: "#000",
                fill: "#fff",
            }}
            cx={239.354}
            cy={124.556}
            rx={66.009}
            ry={64.287}
        />
        <ellipse
            style={{
                fillRule: "nonzero",
                paintOrder: "stroke",
                stroke: "#c65656",
                fill: `${"#c65656"}`,
            }}
            cx={364.587}
            cy={384.211}
            rx={111.354}
            ry={105.901}
        />
        <text
            style={{
                whiteSpace: "pre",
                fill: "#333",
                fontFamily: "Arial,sans-serif",
                fontSize: "16.1px",
            }}
            x={335.211}
            y={365.632}
        />
        <path
            style={{
                fill: "#fff",
                stroke: "#fff",
            }}
            d="m420.717 316.825 18.368 18.368-123.982 117.094-21.238-17.22"
        />
    </svg>
);
export const UnblockUserIcon: React.FC<IconImageProps> = props => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M327.478 475.846c-15.149 26.116 73.945-171.312 72.195-173.062-29.761-29.762-66.236-50.37-106.007-60.423 42.048-20.964 71.004-64.411 71.004-114.5C364.669 57.358 307.311 0 236.809 0c-70.502 0-127.861 57.358-127.861 127.86 0 50.089 28.957 93.536 71.004 114.5-39.771 10.053-76.245 30.661-106.007 60.423-43.502 43.502-67.46 101.341-67.46 162.864 0 5.633 4.566 10.199 10.199 10.199h310.794Z"
            style={{
                strokeWidth: 50,
                strokeMiterlimit: 1,
                fill: `${"#05396b"}`,
            }}
        />
        <ellipse
            style={{
                stroke: "#000",
                fill: "#fff",
            }}
            cx={239.354}
            cy={124.556}
            rx={66.009}
            ry={64.287}
        />
        <ellipse
            style={{
                fill: `${"#88c656"}`,
                fillRule: "nonzero",
                stroke: "#88c656",
            }}
            cx={364.587}
            cy={384.211}
            rx={111.354}
            ry={105.901}
        />
        <text
            style={{
                whiteSpace: "pre",
                fill: "#333",
                fontFamily: "Arial,sans-serif",
                fontSize: "16.1px",
            }}
            x={335.211}
            y={365.632}
        />
        <path
            style={{
                fill: "#fff",
                paintOrder: "fill",
                stroke: "#fff",
            }}
            d="M290.439 374.242v14.35l58.548 63.139 85.524-128.574-9.758-9.758-76.914 97.579-57.4-36.736Z"
        />
    </svg>
);

export const ComposeIcon: React.FC<IconImageProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            viewBox="0 0 24 24"
            width={props.width || 24}
            height={props.height || 24}
        >
            <g
                fill="none"
                fillRule="evenodd"
                id="Action-/-8---Action,-edit,-compose,-new,-pencil-icon"
                stroke="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            >
                <path
                    d="M22,16 L22,21.2 C22,21.6418278 21.6418278,22 21.2,22 L2.8,22 C2.3581722,22 2,21.6418278 2,21.2 L2,2.8 C2,2.3581722 2.3581722,2 2.8,2 L8,2"
                    id="Path"
                    stroke={props.color || "#5b5b5b"}
                    strokeWidth="2"
                />
                <path
                    d="M19.9981337,8.99633418 L11.0527503,17.999822 L6.409568,17.999822 C6.1900421,18.0063958 6.00675181,17.8337639 6.00004437,17.614238 C6.00004437,17.6063045 6.00004437,17.5983655 6.00004437,17.590432 L6.00004437,13 L15.0005937,3.99950542 L19.9981337,8.99633418 Z M21.5887575,7.41064406 L20,9.00496321 L20,9.00496321 L15.0017879,3.99829297 L16.5863759,2.41371468 C17.3674908,1.63281439 18.6337398,1.63277127 19.4149079,2.41361835 L21.586188,4.58458946 C22.3663666,5.36465701 22.3675163,6.62915912 21.5887575,7.41064406 Z"
                    id="Path"
                    stroke={props.color || "#5b5b5b"}
                    strokeWidth="2"
                />
            </g>
        </svg>
    );
};

export const ComposeSettingIcon: React.FC<IconImageProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={props.width || 24}
            height={props.height || 24}
        >
            <defs></defs>
            <g data-name="Layer 2" id="Layer_2">
                <g id="Workspace">
                    <rect fill="none" />
                    <path
                        fill="none"
                        stroke={props.color || "#5b5b5b"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.22,7l.28-2h3l.28,2a5.53,5.53,0,0,1,1.69,1l1.84-.74,1.5,2.6L17.25,11a5.33,5.33,0,0,1,0,2l1.56,1.22-1.5,2.6-1.84-.74a4.58,4.58,0,0,1-.8.56,4.73,4.73,0,0,1-.89.41l-.28,2h-3l-.28-2a5.53,5.53,0,0,1-1.69-1l-1.84.74-1.5-2.6L6.75,13a5.33,5.33,0,0,1,0-2L5.19,9.8l1.5-2.6,1.84.74a4.58,4.58,0,0,1,.8-.56A4.73,4.73,0,0,1,10.22,7Z"
                    />
                    <circle
                        fill="none"
                        stroke={props.color || "#5b5b5b"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        cx="12"
                        cy="12"
                        r="2.5"
                    />
                </g>
            </g>
        </svg>
    );
};

export const QuestionCircleIcon: React.FC<IconImageProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color || ThemeConstants.ICON_COLOR}
                d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108 0a8 8 0 000 16z"
            ></path>
            <path
                fill={props.color || ThemeConstants.ICON_COLOR}
                d="M5.255 5.786a.237.237 0 00.241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 00.25.246h.811a.25.25 0 00.25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
            ></path>
        </svg>
    );
};
export const CheckCircleIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width={props.width || 24}
            height={props.height || 24}
        >
            <path
                fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props.color}
                d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
            ></path>
        </svg>
    );
};
export const MinusCircleIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width={props.width || 24}
            height={props.height || 24}
        >
            <path
                fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props.color}
                d="M140 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H140zm364-28c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z"
            ></path>
        </svg>
    );
};
export const PlusCircleIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 18}
            height={props.height || 18}
            fill="none"
            viewBox="0 0 16 17"
        >
            <path fill="#fff" fillOpacity="0.01" d="M0 0H16V16H0z" transform="translate(0 .5)"></path>
            <g fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props.color} clipPath="url(#clip1_706_5050)">
                <path d="M8 15.5a7 7 0 110-14 7 7 0 010 14zm0 1a8 8 0 100-16 8 8 0 000 16z"></path>
                <path
                    fill={props.disabled ? ThemeConstants.ICON_DISABLE_COLOR : props.color}
                    d="M8 4.5a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 11-1 0V9h-3a.5.5 0 010-1h3V5a.5.5 0 01.5-.5z"
                ></path>
            </g>

            <defs>
                <clipPath id="clip0_706_5050">
                    <path fill="#fff" d="M0 0H16V16H0z" transform="translate(0 .5)"></path>
                </clipPath>
                <clipPath id="clip1_706_5050">
                    <path fill="#fff" d="M0 0H16V16H0z" transform="translate(0 .5)"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const SearchIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 487.95 487.95"
        enableBackground="new 0 0 487.95 487.95"
        xmlSpace="preserve"
        width={props.width || 16}
        height={props.height || 18}
        fill={props?.color ?? ThemeConstants.ICON_COLOR}
    >
        <path d="m481.8 453-140-140.1c27.6-33.1 44.2-75.4 44.2-121.6C386 85.9 299.5.2 193.1.2S0 86 0 191.4s86.5 191.1 192.9 191.1c45.2 0 86.8-15.5 119.8-41.4l140.5 140.5c8.2 8.2 20.4 8.2 28.6 0 8.2-8.2 8.2-20.4 0-28.6zM41 191.4c0-82.8 68.2-150.1 151.9-150.1s151.9 67.3 151.9 150.1-68.2 150.1-151.9 150.1S41 274.1 41 191.4z" />
    </svg>
);
export const GripIcon: React.FC<IconImageProps> = props => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={props.width || 23}
        height={props.height || 22}
        fill="none" viewBox="0 0 23 22">
        <g clipPath="url(#clip0_9397_13922)">
            <path fill="#fff" fillOpacity="0.01" d="M0 0H22V22H0z" transform="translate(.057)"></path>
            <path
                fill={props.color || ThemeConstants.ICON_COLOR}
                d="M9.685 2.751a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm4.125 0a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zM9.685 6.876a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm4.125 0a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm-4.125 4.125a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm4.125 0a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm-4.125 4.125a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm4.125 0a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm-4.125 4.125a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zm4.125 0a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_9397_13922">
                <path fill="#fff" d="M0 0H22V22H0z" transform="translate(.057)"></path>
            </clipPath>
        </defs>
    </svg>
);

export const CloseIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width}
        height={props.height}
        x="0"
        y="0"
        enableBackground="new 0 0 371.23 371.23"
        version="1.1"
        viewBox="0 0 371.23 371.23"
        xmlSpace="preserve"
    >
        <path
            fill={props.color ?? ThemeConstants.ICON_COLOR}
            d="M371.23 21.213L350.018 0 185.615 164.402 21.213 0 0 21.213 164.402 185.615 0 350.018 21.213 371.23 185.615 206.828 350.018 371.23 371.23 350.018 206.828 185.615z"
        ></path>
    </svg>
);

export const PrintDocumentIcon: React.FC<IconImageProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width ?? "16"}
            height={props?.width ?? "14"}
            fill="none"
            viewBox="0 0 16 14"
        >
            <path fill={props?.color || ThemeConstants.ICON_COLOR} d="M2.5 7a.5.5 0 100-1 .5.5 0 000 1z"></path>
            <path
                fill={props?.color || ThemeConstants.ICON_COLOR}
                d="M5 0a2 2 0 00-2 2v2H2a2 2 0 00-2 2v3a2 2 0 002 2h1v1a2 2 0 002 2h6a2 2 0 002-2v-1h1a2 2 0 002-2V6a2 2 0 00-2-2h-1V2a2 2 0 00-2-2H5zM4 2a1 1 0 011-1h6a1 1 0 011 1v2H4V2zm1 5a2 2 0 00-2 2v1H2a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-1 1h-1V9a2 2 0 00-2-2H5zm7 2v3a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h6a1 1 0 011 1z"
            ></path>
        </svg>
    );
};

export const PreviewIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            width={props.width || "16"}
            height={props.height || "16"}
            fill={props.color}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
        >
            <path
                fill={props.color ?? ThemeConstants.ICON_COLOR}
                d="M16 8C16 8 13 2.5 8 2.5C3 2.5 0 8 0 8C0 8 3 13.5 8 13.5C13 13.5 16 8 16 8ZM1.173 8C1.65651 7.26512 2.21264 6.58069 2.833 5.957C4.12 4.668 5.88 3.5 8 3.5C10.12 3.5 11.879 4.668 13.168 5.957C13.7884 6.58069 14.3445 7.26512 14.828 8C14.77 8.087 14.706 8.183 14.633 8.288C14.298 8.768 13.803 9.408 13.168 10.043C11.879 11.332 10.119 12.5 8 12.5C5.88 12.5 4.121 11.332 2.832 10.043C2.21165 9.41931 1.65652 8.73487 1.173 8Z"
            ></path>
            <path
                d="M8 5.5C7.33696 5.5 6.70107 5.76339 6.23223 6.23223C5.76339 6.70107 5.5 7.33696 5.5 8C5.5 8.66304 5.76339 9.29893 6.23223 9.76777C6.70107 10.2366 7.33696 10.5 8 10.5C8.66304 10.5 9.29893 10.2366 9.76777 9.76777C10.2366 9.29893 10.5 8.66304 10.5 8C10.5 7.33696 10.2366 6.70107 9.76777 6.23223C9.29893 5.76339 8.66304 5.5 8 5.5ZM4.5 8C4.5 7.07174 4.86875 6.1815 5.52513 5.52513C6.1815 4.86875 7.07174 4.5 8 4.5C8.92826 4.5 9.8185 4.86875 10.4749 5.52513C11.1313 6.1815 11.5 7.07174 11.5 8C11.5 8.92826 11.1313 9.8185 10.4749 10.4749C9.8185 11.1313 8.92826 11.5 8 11.5C7.07174 11.5 6.1815 11.1313 5.52513 10.4749C4.86875 9.8185 4.5 8.92826 4.5 8Z"
                fill={props.color ?? ThemeConstants.ICON_COLOR}
            ></path>
        </svg>
    );
};

export const AddFolderIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width ?? "16"}
            height={props?.height ?? "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g fill={props?.color ?? ThemeConstants.ICON_COLOR} clipPath="url(#clip0_2203_448500)">
                <path d="M.5 3l.04.87a1.99 1.99 0 00-.342 1.311l.637 7A2 2 0 002.826 14H9v-1H2.826a1 1 0 01-.995-.91l-.637-7A1 1 0 012.19 4h11.62a1 1 0 01.996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0013.81 3H9.828a2 2 0 01-1.414-.586l-.828-.828A2 2 0 006.172 1H2.5a2 2 0 00-2 2zm5.672-1a1 1 0 01.707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 011-.98h3.672z"></path>
                <path d="M13.5 10a.5.5 0 01.5.5V12h1.5a.5.5 0 010 1H14v1.5a.5.5 0 01-1 0V13h-1.5a.5.5 0 010-1H13v-1.5a.5.5 0 01.5-.5z"></path>
            </g>
            <defs>
                <clipPath id="clip0_2203_448500">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

// Access Denied Icons
export const AccessDeniedIcon: React.FC<IconImageProps> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} fill="none" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="100" fill="#E6EBF0"></circle>
        <path
            fill="#B4C3D3"
            d="M132.974 47.887H67.026c-10.571.004-19.135 8.492-19.139 18.97v65.362c0 1.45 1.187 2.626 2.65 2.626 1.463 0 2.65-1.176 2.65-2.626V79.287h93.626v52.932c.004 7.574-6.19 13.713-13.832 13.716H67.026c-2.403 0-4.763-.623-6.85-1.8a2.662 2.662 0 00-3.544 1.208 2.614 2.614 0 00.922 3.345 19.288 19.288 0 009.472 2.486h65.948c10.571 0 19.139-8.492 19.139-18.969V66.856c-.004-10.477-8.572-18.965-19.139-18.969zm13.839 18.97v7.178H53.187v-7.179c-.004-7.574 6.19-13.713 13.832-13.716h65.955c7.642-.004 13.836 6.135 13.839 13.71v.006z"
        ></path>
        <path
            fill="#B4C3D3"
            d="M80.285 60.094a3.286 3.286 0 10-.007 6.573 3.286 3.286 0 003.29-3.283v-.007a3.284 3.284 0 00-3.283-3.283zM67.61 60.094c-2.075-.004-3.756 1.467-3.76 3.283-.004 1.815 1.677 3.286 3.752 3.29 2.075.003 3.755-1.468 3.76-3.283v-.007c-.004-1.812-1.681-3.28-3.752-3.283zM94.37 60.094a3.286 3.286 0 10-.007 6.573 3.286 3.286 0 00.007-6.573zM86.671 122.693c.372.396.813.711 1.3.926a3.805 3.805 0 001.534.325c.526 0 1.047-.111 1.534-.325.486-.215.927-.53 1.299-.926l7.709-8.193 7.714 8.193a3.884 3.884 0 002.804 1.143 3.9 3.9 0 002.764-1.248 4.397 4.397 0 001.174-2.938 4.42 4.42 0 00-1.076-2.98l-7.708-8.192 7.708-8.193a4.409 4.409 0 001.127-2.996 4.4 4.4 0 00-1.173-2.977 3.894 3.894 0 00-2.8-1.25 3.884 3.884 0 00-2.82 1.195l-7.714 8.193-7.71-8.193a4.014 4.014 0 00-1.3-.954 3.804 3.804 0 00-3.1-.027c-.494.214-.942.531-1.318.931-.376.4-.674.876-.875 1.4a4.495 4.495 0 00.028 3.296c.21.52.516.99.9 1.382l7.687 8.193-7.709 8.192a4.295 4.295 0 00-.865 1.385 4.493 4.493 0 00.012 3.26c.203.516.5.984.874 1.378z"
        ></path>
    </svg>
);

export const DisabledByTierIcon: React.FC<IconImageProps> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} fill="none" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="100" fill="#E6EBF0"></circle>
        <path
            fill="#B4C3D3"
            fillRule="evenodd"
            stroke="#B4C3D3"
            strokeWidth="3"
            d="M134.19 64.856a48.503 48.503 0 0110.622 16.001 48.39 48.39 0 01-4.706 45.2 48.403 48.403 0 01-17.391 15.682 48.372 48.372 0 01-50.907-3.37 48.317 48.317 0 01-17.62-23.796 48.746 48.746 0 01-2.223-21.138 2.46 2.46 0 114.885.57A43.851 43.851 0 0058.847 113a43.528 43.528 0 009.248 15.543c.396-.535.854-1.066 1.358-1.57l58.739-58.74c.41-.409.838-.788 1.271-1.128a43.428 43.428 0 00-13.121-8.315 43.79 43.79 0 00-32.69 0 43.141 43.141 0 00-14.373 9.545 2.461 2.461 0 01-4.012-.798 2.459 2.459 0 01.533-2.68 48.055 48.055 0 0116-10.624 48.682 48.682 0 0136.391 0 48.502 48.502 0 0115.999 10.623zm-1.282 5.81a43.427 43.427 0 01-2.193 59.109 43.198 43.198 0 01-14.373 9.541 43.74 43.74 0 01-32.69 0 43.513 43.513 0 01-12.067-7.396 14.104 14.104 0 001.505-1.309l58.74-58.74c.389-.389.751-.795 1.078-1.206z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const ProductDisabledIcon: React.FC<IconImageProps> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} fill="none" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="100" fill="#E6EBF0"></circle>
        <path
            fill="#B4C3D3"
            d="M76.552 72.227c.351-.72.403-1.55.144-2.31a3.019 3.019 0 00-1.523-1.735 2.997 2.997 0 00-2.3-.144c-.755.26-1.376.81-1.727 1.53L42.382 128.57c-1.203 2.461-4.411 9.004 1.204 13.5 8.382 6.696 32.164 10.048 55.954 10.044 23.791-.004 47.57-3.348 55.936-10.044 5.614-4.496 2.406-11.043 1.203-13.5l-37.411-76.775a22.032 22.032 0 00-8.103-9.015 21.897 21.897 0 00-11.625-3.342c-4.11 0-8.137 1.158-11.624 3.342a22.035 22.035 0 00-8.103 9.014 3.035 3.035 0 00-.146 2.31 3.018 3.018 0 001.521 1.735 2.997 2.997 0 002.299.147 3.014 3.014 0 001.728-1.529 15.997 15.997 0 015.883-6.549 15.897 15.897 0 0116.885 0 15.991 15.991 0 015.883 6.55l37.435 76.771c2.093 4.294 1.431 5.31.425 6.115-14.631 11.716-89.744 11.716-104.375 0-1.002-.805-1.664-1.817.434-6.115l28.767-59z"
        ></path>
        <path
            fill="#B4C3D3"
            d="M104.225 104.464V76.757c0-.933-.445-1.828-1.237-2.487-.793-.66-1.867-1.03-2.988-1.03-1.12 0-2.195.37-2.988 1.03-.792.66-1.237 1.554-1.237 2.487v27.707c0 .933.445 1.827 1.237 2.487.793.66 1.867 1.03 2.988 1.03s2.195-.37 2.988-1.03c.792-.66 1.237-1.554 1.237-2.487zM93.897 122.066c0 1.114.358 2.203 1.028 3.129a6.016 6.016 0 002.738 2.075 6.573 6.573 0 003.526.322 6.28 6.28 0 003.125-1.541 5.511 5.511 0 001.671-2.883 5.234 5.234 0 00-.345-3.255 5.75 5.75 0 00-2.246-2.529 6.466 6.466 0 00-3.389-.952c-1.62 0-3.172.593-4.317 1.65-1.146 1.056-1.79 2.489-1.791 3.984z"
        ></path>
    </svg>
);

export const NoPermissionIcon: React.FC<IconImageProps> = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} fill="none" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="100" fill="#E6EBF0"></circle>
        <path
            fill="#B4C3D3"
            fillRule="evenodd"
            stroke="#B4C3D3"
            strokeWidth="3"
            d="M121.382 80.957a29.676 29.676 0 016.497 9.786A29.59 29.59 0 01125 118.39a29.592 29.592 0 01-41.774 7.531 29.555 29.555 0 01-10.778-14.555 29.818 29.818 0 01-1.36-12.93 1.504 1.504 0 112.989.35 26.815 26.815 0 001.221 11.617 26.628 26.628 0 005.657 9.508c.242-.327.522-.652.83-.96l35.928-35.928c.251-.251.512-.483.777-.691a26.55 26.55 0 00-8.025-5.086 26.784 26.784 0 00-19.995 0 26.386 26.386 0 00-8.791 5.838 1.505 1.505 0 01-2.128-2.127 29.392 29.392 0 019.786-6.498 29.776 29.776 0 0122.259 0 29.678 29.678 0 019.786 6.498zm-.784 3.553a26.569 26.569 0 01-1.342 36.154 26.437 26.437 0 01-8.791 5.836 26.756 26.756 0 01-19.995 0 26.626 26.626 0 01-7.38-4.524c.313-.235.624-.505.92-.8l35.928-35.929c.238-.238.46-.486.66-.737z"
            clipRule="evenodd"
        ></path>
        <path
            fill="#B4C3D3"
            d="M154.848 59.189a86.865 86.865 0 01-49.325-14.326 9.807 9.807 0 00-10.951 0A86.466 86.466 0 0150.249 59.19a9.758 9.758 0 00-6.084 2.41 9.742 9.742 0 00-3.188 5.71c-3.046 17.357-7.99 75.513 56.179 94.721a10.07 10.07 0 002.891.411c.978.001 1.951-.139 2.888-.415 75.79-22.696 55.109-99.968 54.893-100.745a2.877 2.877 0 00-2.98-2.092zm-1.417 42.857c-5.129 27.313-22.68 45.647-52.159 54.475-.8.238-1.653.238-2.453 0-19.318-5.805-63.075-25.978-52.155-88.22a4.023 4.023 0 013.82-3.35 92.303 92.303 0 0047.338-15.318 3.976 3.976 0 014.451 0 90.733 90.733 0 0050.507 15.388 97.877 97.877 0 01.651 37.025z"
        ></path>
    </svg>
);


export const DownloadNowIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        enableBackground="new 0 0 512 512"
        xmlSpace="preserve"
        height={props.height}
        width={props.width}
    >
        <path
            style={{
                fill: "#f6e27d",
            }}
            d="M488.727 271.515H333.576c-12.853 0-23.273 10.42-23.273 23.273v54.303H201.697v-54.303c0-12.853-10.42-23.273-23.273-23.273H23.273C10.42 271.515 0 281.935 0 294.788v170.667c0 12.853 10.42 23.273 23.273 23.273h465.454c12.853 0 23.273-10.42 23.273-23.273V294.788c0-12.853-10.42-23.273-23.273-23.273z"
        />
        <path
            style={{
                fill: "#ffa733",
            }}
            d="m286.09 169.726-6.817 6.816V46.545c0-12.853-10.42-23.273-23.273-23.273s-23.273 10.42-23.273 23.273v129.997l-6.817-6.817c-9.087-9.089-23.824-9.089-32.912 0-9.089 9.087-9.089 23.824 0 32.912l46.542 46.542.003.003c.549.549 1.12 1.061 1.707 1.542.264.216.546.41.818.613.335.251.666.512 1.008.743.329.219.676.413 1.015.614.312.188.619.385.939.554.344.185.704.343 1.06.51.334.158.664.326 1.004.465.343.143.698.259 1.049.385.366.13.731.273 1.102.385.348.105.704.185 1.06.273.383.098.763.203 1.15.282.403.079.816.127 1.227.186.341.05.68.113 1.024.147.752.079 1.52.119 2.294.119s1.541-.04 2.296-.116c.344-.033.683-.098 1.024-.147.411-.059.824-.107 1.227-.186.386-.079.766-.185 1.15-.282.355-.088.712-.166 1.06-.273.371-.112.735-.254 1.102-.385.349-.126.706-.242 1.049-.385.341-.14.672-.307 1.004-.465.355-.168.715-.326 1.06-.51.318-.169.625-.366.939-.554.34-.203.686-.397 1.015-.614.344-.23.675-.49 1.008-.743.273-.203.554-.397.818-.613a24.64 24.64 0 0 0 1.707-1.542l.003-.003 46.542-46.542c9.089-9.087 9.089-23.824 0-32.912s-23.827-9.092-32.914-.002z"
        />
        <path
            style={{
                fill: "#f5dc60",
            }}
            d="M201.697 349.091v-54.303c0-12.853-10.42-23.273-23.273-23.273H23.273C10.42 271.515 0 281.935 0 294.788v170.667c0 12.853 10.42 23.273 23.273 23.273H256V349.091h-54.303z"
        />
        <path
            style={{
                fill: "#ff7956",
            }}
            d="M232.727 46.545v129.997l-6.817-6.817c-9.087-9.089-23.824-9.089-32.912 0-9.089 9.087-9.089 23.824 0 32.912l46.542 46.542.003.003c.549.549 1.12 1.061 1.707 1.542.264.216.546.41.818.613.335.251.666.512 1.008.743.329.219.676.413 1.015.614.312.188.619.385.937.554.344.185.704.343 1.06.51.334.158.664.326 1.004.465.343.143.698.259 1.049.385.366.13.731.273 1.102.385.348.105.704.185 1.06.273.383.098.763.203 1.15.282.403.079.816.127 1.227.186.341.05.68.113 1.024.147.754.076 1.52.116 2.295.116V23.273c-12.852 0-23.272 10.42-23.272 23.272z"
        />
    </svg>
);

export const DownloadLaterIcon: React.FC<IconImageProps> = props => (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#a)">
            <path
                d="M30 0a30 30 0 1 0 30 30A30.032 30.032 0 0 0 30 0Zm0 55a25 25 0 1 1 25-25 25.027 25.027 0 0 1-25 25Z"
                fill={ThemeConstants.ICON_COLOR}
            />
            <circle cx={30} cy={30} r={25} fill="#fff" />
            <path
                d="M27.52 27.004V40.97a2.5 2.5 0 1 0 5 0v-15a2.5 2.5 0 0 0-.733-1.767l-7.5-7.5a2.5 2.5 0 0 0-3.535 3.535l6.767 6.767Z"
                fill={ThemeConstants.ICON_COLOR}
            />
            <path
                d="M49.246 44.965H36.469c-1.058 0-1.916.757-1.916 1.692v3.95h-8.944v-3.95c0-.934-.858-1.692-1.916-1.692H10.916c-1.058 0-1.916.757-1.916 1.692v12.414c0 .935.858 1.693 1.916 1.693h38.33c1.058 0 1.916-.758 1.916-1.693V46.657c0-.934-.858-1.692-1.916-1.692Z"
                fill="#F6E27D"
            />
            <path
                d="m32.559 37.56-.561.496v-9.455c0-.935-.858-1.693-1.917-1.693-1.058 0-1.916.758-1.916 1.693v9.456l-.562-.496c-.748-.661-1.962-.661-2.71 0-.748.66-.748 1.733 0 2.394l3.833 3.385c.045.04.092.077.14.112.022.016.045.03.068.045.027.018.055.037.083.054.027.016.056.03.083.045.026.013.051.028.078.04.028.013.058.025.087.037.027.011.055.024.083.034l.086.028c.03.01.06.02.09.028s.059.013.088.02l.095.02c.033.006.067.01.1.014.029.003.057.008.085.01a2.028 2.028 0 0 0 .378 0c.029-.002.056-.006.085-.01.033-.004.067-.008.1-.014.032-.005.064-.013.095-.02.03-.007.059-.012.087-.02.031-.008.061-.018.091-.028.029-.01.058-.017.087-.028.028-.01.055-.022.082-.034.03-.012.06-.023.088-.037.026-.012.051-.027.077-.04.028-.015.056-.029.083-.045.029-.017.056-.035.084-.054l.067-.044c.048-.036.095-.073.14-.113l3.833-3.385c.749-.661.749-1.733 0-2.394-.748-.661-1.962-.661-2.71 0Z"
                fill="#FFA733"
            />
            <path
                d="M25.61 50.607v-3.95c0-.934-.859-1.692-1.917-1.692H10.916c-1.058 0-1.916.757-1.916 1.692v12.414c0 .935.858 1.693 1.916 1.693h19.165V50.607H25.61Z"
                fill="#F5DC60"
            />
            <path
                d="M28.165 28.6v9.456l-.562-.495c-.748-.661-1.962-.661-2.71 0-.748.66-.748 1.733 0 2.394l3.833 3.385c.045.04.092.077.14.112.022.016.045.03.068.045.027.018.055.037.083.054.027.016.056.03.083.045.026.013.051.028.078.04.028.013.057.025.087.037.027.011.055.024.082.034l.087.028c.03.01.06.02.09.028s.059.013.088.02l.095.02c.033.006.067.01.1.014.029.003.057.008.085.01.062.006.125.009.189.009V26.908c-1.058 0-1.916.758-1.916 1.693Z"
                fill="#FF7956"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h60v60H0z" />
            </clipPath>
        </defs>
    </svg>
);

export const PendingIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        enableBackground="new 0 0 32 32"
        xmlSpace="preserve"
        height={props.height}
        width={props.width}
        fill={props.color}
        className="pending-icon-animate"
    >
        <path d="M16 2c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM10.3 6.1C9.2 5 7.2 5 6.1 6.1c-1.2 1.2-1.2 3.1 0 4.2.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9c1.2-1.1 1.2-3 0-4.2zM8 16c0-1.7-1.3-3-3-3s-3 1.3-3 3 1.3 3 3 3 3-1.3 3-3zM6.1 21.7c-1.2 1.2-1.2 3.1 0 4.2.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9c1.2-1.2 1.2-3.1 0-4.2-1.1-1.2-3.1-1.2-4.2 0zM16 24c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM21.7 21.7c-1.2 1.2-1.2 3.1 0 4.2.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9c1.2-1.2 1.2-3.1 0-4.2-1.1-1.2-3.1-1.2-4.2 0zM27 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zM23.8 11.2c.8 0 1.6-.3 2.1-.9 1.2-1.2 1.2-3.1 0-4.2-1.1-1.1-3.1-1.1-4.2 0-1.2 1.2-1.2 3.1 0 4.2.5.6 1.3.9 2.1.9z" />
    </svg>
);

export const ZipperIcon: React.FC<IconImageProps> = props => (
    <svg
        width={props.width || 24}
        height={props.height || 24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_149_56)">
            <path
                d="M22.7586 4.13793H17.7931H16.9878H14.8965H14.0912H12H11.1947C10.6502 4.13793 10.1276 3.92329 9.74034 3.54051L8.43717 2.25257C8.0498 1.86979 7.52728 1.65515 6.98278 1.65515H4.13794H1.24139C0.555797 1.65515 0 2.21095 0 2.89654V5.37932V5.79314V21.1035C0 21.7891 0.555797 22.3449 1.24139 22.3449H22.7586C23.4442 22.3449 24 21.7891 24 21.1035V5.37932C24 4.69368 23.4442 4.13793 22.7586 4.13793ZM12.7793 17.9104H10.4207C10.2036 17.9104 10.0276 17.7343 10.0276 17.5173C10.0276 17.3209 10.1721 17.1595 10.3603 17.1303L9.60239 15.2897H6.25969L5.50181 17.1302C5.69002 17.1594 5.83448 17.3209 5.83448 17.5172C5.83448 17.7343 5.65852 17.9103 5.44139 17.9103H4.92286C4.92136 17.9104 4.91981 17.9103 4.91831 17.9103H4.39308C4.17595 17.9103 3.99998 17.7343 3.99998 17.5172C3.99998 17.3002 4.17595 17.1241 4.39308 17.1241H4.65389L8.22267 8.45714C8.28333 8.31 8.42686 8.21371 8.58623 8.21371C8.74561 8.21371 8.88914 8.3099 8.9498 8.45714L12.5186 17.1241H12.7794C12.9965 17.1241 13.1725 17.3002 13.1725 17.5172C13.1724 17.7343 12.9965 17.9104 12.7793 17.9104ZM19.331 17.9104H18.0207C17.7283 17.9104 17.4704 17.7703 17.3023 17.5565C16.8294 17.7981 16.3909 17.9104 15.9241 17.9104H15.4C14.5401 17.9104 13.8822 17.5623 13.5951 16.955C13.3405 16.4168 13.4426 15.7652 13.8614 15.2549C14.4014 14.5966 15.1478 14.4751 15.938 14.3464C16.3176 14.2844 16.7082 14.217 17.1035 14.0909V13.8483C17.1035 13.2384 16.7624 12.4069 16.1863 12.4069C15.6102 12.4069 15.2691 13.2384 15.2691 13.8483C15.2691 14.0654 15.0931 14.2414 14.876 14.2414H13.8277C13.6105 14.2414 13.4346 14.0654 13.4346 13.8483C13.4346 12.6202 14.4338 11.6208 15.6622 11.6208H16.7105C17.9388 11.6208 18.9381 12.6202 18.9381 13.8483V16.9932C18.9381 17.0654 18.9968 17.1242 19.0691 17.1242H19.3312C19.5483 17.1242 19.7242 17.3003 19.7242 17.5173C19.7241 17.7343 19.5482 17.9104 19.331 17.9104Z"
                fill="#FFDC69"
            />
            <path d="M6.58337 14.5035H9.27864L7.93098 11.2306L6.58337 14.5035Z" fill="#FFDC69" />
            <path
                d="M15.513 15.7675C15.2357 16.0748 15.2314 16.4818 15.35 16.7487C15.4125 16.8889 15.5699 17.1241 15.924 17.1241C16.3088 17.1241 16.6791 17.0142 17.1034 16.7715V14.9491C16.5013 15.1386 15.8614 15.3811 15.513 15.7675Z"
                fill="#FFDC69"
            />
            <path
                d="M12.7794 17.1241H12.5185L8.94976 8.45714C8.88911 8.31 8.74558 8.21371 8.5862 8.21371C8.42683 8.21371 8.2833 8.3099 8.22264 8.45714L4.65391 17.1241H4.39309C4.17597 17.1241 4 17.3002 4 17.5172C4 17.7343 4.17597 17.9103 4.39309 17.9103H4.91828C4.91978 17.9103 4.92133 17.9104 4.92283 17.9103H5.44136C5.65848 17.9103 5.83445 17.7343 5.83445 17.5172C5.83445 17.3209 5.68998 17.1594 5.50178 17.1302L6.25966 15.2896H9.60236L10.3603 17.1302C10.1721 17.1594 10.0276 17.3209 10.0276 17.5172C10.0276 17.7342 10.2036 17.9103 10.4207 17.9103H12.7793C12.9964 17.9103 13.1724 17.7342 13.1724 17.5172C13.1725 17.3002 12.9965 17.1241 12.7794 17.1241ZM6.58338 14.5034L7.93098 11.2306L9.27864 14.5034H6.58338Z"
                fill="#FFDC69"
            />
            <path
                d="M19.331 17.1242H19.0689C18.9966 17.1242 18.9379 17.0653 18.9379 16.9931V13.8482C18.9379 12.6201 17.9386 11.6207 16.7103 11.6207H15.662C14.4337 11.6207 13.4344 12.6201 13.4344 13.8482C13.4344 14.0653 13.6104 14.2413 13.8275 14.2413H14.8759C15.093 14.2413 15.2689 14.0653 15.2689 13.8482C15.2689 13.2384 15.6101 12.4068 16.1862 12.4068C16.7622 12.4068 17.1034 13.2384 17.1034 13.8482V14.0909C16.7081 14.2169 16.3175 14.2843 15.9379 14.3463C15.1477 14.475 14.4013 14.5966 13.8613 15.2548C13.4425 15.7652 13.3404 16.4167 13.595 16.9549C13.8822 17.5622 14.54 17.9103 15.3999 17.9103H15.924C16.3907 17.9103 16.8293 17.798 17.3022 17.5564C17.4703 17.7702 17.7282 17.9103 18.0206 17.9103H19.3309C19.548 17.9103 19.724 17.7342 19.724 17.5172C19.7241 17.3002 19.5482 17.1242 19.331 17.1242ZM17.1034 16.7715C16.6792 17.0143 16.3089 17.1242 15.9241 17.1242C15.5699 17.1242 15.4125 16.889 15.3501 16.7487C15.2315 16.4817 15.2358 16.0748 15.5131 15.7675C15.8615 15.3811 16.5012 15.1386 17.1034 14.9491V16.7715Z"
                fill="#FFDC69"
            />
            <path
                d="M22.9295 11.5341C23.0005 11.7579 23.2392 11.8818 23.463 11.8108C23.6869 11.7398 23.8107 11.5011 23.7398 11.2772L23.2261 9.65672C23.1552 9.43291 22.9164 9.309 22.6926 9.38C22.4688 9.45096 22.3449 9.68972 22.4159 9.91353L22.9295 11.5341Z"
                fill="white"
            />
            <path
                d="M21.3093 12.0477C21.3802 12.2715 21.619 12.3954 21.8428 12.3244C22.0666 12.2534 22.1905 12.0147 22.1195 11.7909L21.6059 10.1704C21.5349 9.94657 21.2959 9.82269 21.0724 9.89366C20.8486 9.96462 20.7247 10.2034 20.7957 10.4272L21.3093 12.0477Z"
                fill="white"
            />
            <path
                d="M23.2264 15.7043L23.74 14.0844C23.74 14.0837 23.74 14.0837 23.74 14.0837C23.811 13.8603 23.6871 13.6212 23.4633 13.5502C23.2395 13.4792 23.0007 13.6031 22.9298 13.8272L22.4162 15.4477C22.3452 15.6712 22.4691 15.9103 22.6928 15.9813C22.9167 16.0523 23.1554 15.9284 23.2264 15.7043Z"
                fill="white"
            />
            <path
                d="M21.6059 15.1907L22.1195 13.5702C22.1905 13.3467 22.0666 13.1079 21.8428 13.0369C21.619 12.9659 21.3802 13.0898 21.3093 13.3136L20.7957 14.9341C20.7247 15.1576 20.8486 15.3967 21.0724 15.4677C21.2959 15.5387 21.535 15.4147 21.6059 15.1907Z"
                fill="white"
            />
            <path
                d="M10.5848 14.3807C10.8195 14.3807 11.01 14.1902 11.01 13.9555V12.6808C11.01 12.9155 11.1999 13.1057 11.4346 13.1057C11.6692 13.1057 11.8597 12.9155 11.8597 12.6808V10.9806C11.8597 10.7459 11.6693 10.5557 11.4346 10.5557C11.1998 10.5557 11.01 10.7459 11.01 10.9806V12.2556C11.01 12.0209 10.8195 11.8307 10.5848 11.8307C10.3501 11.8307 10.1596 12.0209 10.1596 12.2556V10.9806C10.1596 10.7459 9.96965 10.5557 9.73496 10.5557C9.50028 10.5557 9.30978 10.7459 9.30978 10.9806V12.2556C9.30978 12.0209 9.11928 11.8307 8.88459 11.8307C8.64986 11.8307 8.46 12.0209 8.46 12.2556V10.9806C8.46 10.7459 8.2695 10.5557 8.03477 10.5557C7.80005 10.5557 7.60955 10.7459 7.60955 10.9806V12.2556C7.60955 12.0209 7.41965 11.8307 7.18496 11.8307C6.95027 11.8307 6.75977 12.0209 6.75977 12.2556V10.9806C6.75977 10.7459 6.56927 10.5557 6.33454 10.5557C6.09986 10.5557 5.91004 10.7459 5.91004 10.9806V12.2556C5.91004 12.0209 5.71954 11.8307 5.48481 11.8307C5.25008 11.8307 5.05958 12.0209 5.05958 12.2556V10.9806C5.05958 10.7459 4.86968 10.5557 4.63499 10.5557C4.40031 10.5557 4.20981 10.7459 4.20981 10.9806V12.2556C4.20981 12.0209 4.01931 11.8307 3.78458 11.8307C3.54989 11.8307 3.36003 12.0209 3.36003 12.2556V13.9555C3.36003 14.1902 3.54993 14.3807 3.78458 14.3807C4.01931 14.3807 4.20981 14.1902 4.20981 13.9555L4.20981 12.6808C4.20981 12.9156 4.40027 13.1057 4.63499 13.1057C4.86972 13.1057 5.05958 12.9156 5.05958 12.6808L5.05958 13.9555C5.05958 14.1902 5.25008 14.3807 5.48481 14.3807C5.71954 14.3807 5.91004 14.1902 5.91004 13.9555L5.91004 12.6808C5.91004 12.9156 6.0999 13.1057 6.33454 13.1057C6.56927 13.1057 6.75977 12.9156 6.75977 12.6808L6.75977 13.9555C6.75977 14.1902 6.95027 14.3807 7.18496 14.3807C7.41969 14.3807 7.60955 14.1902 7.60955 13.9555L7.60955 12.6808C7.60955 12.9156 7.80005 13.1057 8.03477 13.1057C8.2695 13.1057 8.46 12.9156 8.46 12.6808V13.9555C8.46 14.1902 8.6499 14.3807 8.88459 14.3807C9.11928 14.3807 9.30978 14.1902 9.30978 13.9555V12.6808C9.30978 12.9156 9.50028 13.1057 9.73496 13.1057C9.96969 13.1057 10.1596 12.9156 10.1596 12.6808V13.9555C10.1596 14.1902 10.3501 14.3807 10.5848 14.3807Z"
                fill="white"
            />
            <path d="M16.11 15.2305L15.2599 14.2108V11.1599L16.11 10.1308H20.3599V15.2305H16.11Z" fill="#CBD0D8" />
            <path
                d="M17.6299 13.1057H18.235C18.4697 13.1057 18.6599 12.9155 18.6599 12.6808C18.6599 12.4461 18.4697 12.2556 18.235 12.2556H17.6299C17.0142 11.4619 14.9744 10.5557 13.9848 10.5557C12.811 10.5557 11.8597 11.507 11.8597 12.6808C11.8597 13.8541 12.811 14.8053 13.9848 14.8053C14.9744 14.8053 17.0142 13.8995 17.6299 13.1057ZM13.5599 12.6808C13.5599 12.4461 13.7501 12.2556 13.9848 12.2556C14.2198 12.2556 14.41 12.4461 14.41 12.6808C14.41 12.9155 14.2198 13.1057 13.9848 13.1057C13.7501 13.1057 13.5599 12.9155 13.5599 12.6808Z"
                fill="#2B2A28"
            />
            <path
                d="M7.22479 14.385C7.45952 14.385 7.64998 14.1945 7.64998 13.9598L7.64998 12.6851C7.64998 12.9198 7.83988 13.11 8.07457 13.11C8.30926 13.11 8.49976 12.9198 8.49976 12.6851V10.9849C8.49976 10.7502 8.3093 10.56 8.07457 10.56C7.83984 10.56 7.64998 10.7502 7.64998 10.9849V12.2599C7.64998 12.0252 7.45952 11.835 7.22479 11.835C6.99007 11.835 6.79957 12.0252 6.79957 12.2599V10.9849C6.79957 10.7502 6.60967 10.56 6.37498 10.56C6.14029 10.56 5.94979 10.7502 5.94979 10.9849V12.2599C5.94979 12.0252 5.75929 11.835 5.5246 11.835C5.28988 11.835 5.10001 12.0252 5.10001 12.2599V10.9849C5.10001 10.7502 4.90952 10.56 4.67479 10.56C4.44006 10.56 4.24956 10.7502 4.24956 10.9849V12.2599C4.24956 12.0252 4.05966 11.835 3.82497 11.835C3.59028 11.835 3.39979 12.0252 3.39979 12.2599V10.9849C3.39979 10.7502 3.20929 10.56 2.97456 10.56C2.73987 10.56 2.55005 10.7502 2.55005 10.9849V12.2599C2.55005 12.0252 2.35955 11.835 2.12482 11.835C1.8901 11.835 1.6996 12.0252 1.6996 12.2599V10.9849C1.6996 10.7502 1.5097 10.56 1.27501 10.56C1.04032 10.56 0.849821 10.7502 0.849821 10.9849V12.2599C0.849821 12.0252 0.659321 11.835 0.424594 11.835C0.189907 11.835 4.49926e-05 12.0252 4.49926e-05 12.2599V13.9598C4.49926e-05 14.1945 0.189947 14.385 0.424594 14.385C0.659321 14.385 0.849821 14.1945 0.849821 13.9598L0.849821 12.6851C0.849821 12.9199 1.04028 13.11 1.27501 13.11C1.50974 13.11 1.6996 12.9199 1.6996 12.6851L1.6996 13.9598C1.6996 14.1945 1.8901 14.385 2.12482 14.385C2.35955 14.385 2.55005 14.1945 2.55005 13.9598L2.55005 12.6851C2.55005 12.9199 2.73991 13.11 2.97456 13.11C3.20929 13.11 3.39979 12.9199 3.39979 12.6851L3.39979 13.9598C3.39979 14.1945 3.59028 14.385 3.82497 14.385C4.0597 14.385 4.24956 14.1945 4.24956 13.9598L4.24956 12.6851C4.24956 12.9199 4.44006 13.11 4.67479 13.11C4.90952 13.11 5.10001 12.9199 5.10001 12.6851V13.9598C5.10001 14.1945 5.28992 14.385 5.5246 14.385C5.75929 14.385 5.94979 14.1945 5.94979 13.9598V12.6851C5.94979 12.9199 6.14029 13.11 6.37498 13.11C6.60971 13.11 6.79957 12.9199 6.79957 12.6851L6.79957 13.9598C6.79957 14.1945 6.99007 14.385 7.22479 14.385Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_149_56">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const FileEarMarkArrowUp: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 12}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 12 16"
    >
        <path
            fill={props.color ?? "#000"}
            d="M6.5 11.5a.5.5 0 01-1 0V7.707L4.354 8.854a.5.5 0 11-.708-.708l2-2a.5.5 0 01.708 0l2 2a.5.5 0 11-.708.708L6.5 7.707V11.5z"
        ></path>
        <path
            fill={props.color ?? "#000"}
            d="M12 14V4.5L7.5 0H2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2zM7.5 3A1.5 1.5 0 009 4.5h2V14a1 1 0 01-1 1H2a1 1 0 01-1-1V2a1 1 0 011-1h5.5v2z"
        ></path>
    </svg>
);
export const FileEarMarkArrowPlus: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 12}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 16 16"
    >
        <path
            fill={props.color ?? "#000"}
            d="M8 6.5a.5.5 0 01.5.5v1.5H10a.5.5 0 010 1H8.5V11a.5.5 0 01-1 0V9.5H6a.5.5 0 110-1h1.5V7a.5.5 0 01.5-.5z"
        ></path>
        <path
            fill={props.color ?? "#000"}
            d="M14 4.5V14a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h5.5L14 4.5zm-3 0A1.5 1.5 0 019.5 3V1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4.5h-2z"
        ></path>
    </svg>
);

export const CheckCircleFill: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? "16"}
        height={props.height ?? "16"}
        fill="none"
        viewBox="0 0 16 16"
    >
        <g clipPath="url(#clip0_2203_449475)">
            <path
                fill={props.color ?? "#669440"}
                d="M16 8A8 8 0 11-.001 8 8 8 0 0116 8zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05h-.001z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2203_449475">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);
export const ExclamationTriangleFill: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props?.width || 16}
        height={props?.height || 16}
        fill="none"
        viewBox="0 0 18 18"
    >
        <g clipPath="url(#clip0_27_52351)">
            <path
                fill={props.color ?? "#CC4A43"}
                d="M10.105 1.762a1.271 1.271 0 00-2.205 0L.186 14.887c-.515.875.102 1.988 1.102 1.988h15.427c1 0 1.618-1.114 1.103-1.988L10.105 1.762zM9 5.625c.602 0 1.073.52 1.012 1.12L9.62 10.69a.621.621 0 01-1.238 0l-.394-3.945A1.018 1.018 0 019 5.625zm.002 6.75a1.125 1.125 0 110 2.25 1.125 1.125 0 010-2.25z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_27_52351">
                <path fill="#fff" d="M0 0H18V18H0z"></path>
            </clipPath>
        </defs>
    </svg>
);
export const BellIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? "16"}
        height={props.height ?? "16"}
        viewBox="0 0 16 16"
    >
        <g clipPath="url(#clip0_551_283510)">
            <path
                fill={props.color ?? ThemeConstants.ICON_COLOR}
                d="M8 16a2 2 0 002-2H6a2 2 0 002 2zM8 1.918l-.797.161A4.002 4.002 0 004 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 00-3.203-3.92L8 1.917v.001zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 111.99 0A5.002 5.002 0 0113 6c0 .88.32 4.2 1.22 6z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_551_283510">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const PlusIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? "16"}
        height={props.height ?? "16"}
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            fill={props.color ?? ThemeConstants.ICON_COLOR}
            fillRule="evenodd"
            d="M10.002 2.5a.625.625 0 01.624.624v6.25h6.25a.625.625 0 010 1.25h-6.25v6.25a.625.625 0 01-1.25 0v-6.25h-6.25a.625.625 0 110-1.25h6.25v-6.25a.625.625 0 01.626-.625z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const MinusIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? "16"}
        height={props.height ?? "16"}
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            fill={props.color ?? ThemeConstants.ICON_COLOR}
            fillRule="evenodd"
            d="M17.503 10a.625.625 0 01-.625.626H3.128a.625.625 0 110-1.25h13.75a.625.625 0 01.625.625z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const ActionDropDownButtonIcon: React.FC<IconImageProps> = (props) => (
    <svg width="14" height="4" viewBox="0 0 14 4" fill={props?.color || "05386B"}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2C3.5 2.82843 2.82843 3.5 2 3.5ZM7 3.5C6.17157 3.5 5.5 2.82843 5.5 2C5.5 1.17157 6.17157 0.5 7 0.5C7.82843 0.5 8.5 1.17157 8.5 2C8.5 2.82843 7.82843 3.5 7 3.5ZM12 3.5C11.1716 3.5 10.5 2.82843 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2C13.5 2.82843 12.8284 3.5 12 3.5Z" />
    </svg>
);

export const PaperClipIcon: React.FC<IconImageProps> = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
        <path
            fill="#212529"
            d="M4.5 3a2.5 2.5 0 115 0v9a1.5 1.5 0 01-3 0V5a.5.5 0 111 0v7a.5.5 0 001 0V3a1.5 1.5 0 00-3 0v9a2.5 2.5 0 005 0V5a.5.5 0 011 0v7a3.5 3.5 0 11-7 0V3z"
        ></path>
    </svg>
);

export const DeleteIconWithBox: React.FC<IconImageProps> = () => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.4">
            <rect x="0.5" y="0.5" width="37" height="37" rx="1.5" fill="white" fillOpacity="0.01" />
            <rect x="0.5" y="0.5" width="37" height="37" rx="1.5" stroke="#6B7075" />
            <path
                d="M17.5 12H20.5C20.6326 12 20.7598 12.0527 20.8536 12.1464C20.9473 12.2402 21 12.3674 21 12.5V13.5H17V12.5C17 12.3674 17.0527 12.2402 17.1464 12.1464C17.2402 12.0527 17.3674 12 17.5 12ZM22 13.5V12.5C22 12.1022 21.842 11.7206 21.5607 11.4393C21.2794 11.158 20.8978 11 20.5 11H17.5C17.1022 11 16.7206 11.158 16.4393 11.4393C16.158 11.7206 16 12.1022 16 12.5V13.5H13.506C13.5027 13.5 13.4993 13.5 13.496 13.5H12.5C12.3674 13.5 12.2402 13.5527 12.1464 13.6464C12.0527 13.7402 12 13.8674 12 14C12 14.1326 12.0527 14.2598 12.1464 14.3536C12.2402 14.4473 12.3674 14.5 12.5 14.5H13.038L13.891 25.16C13.9312 25.6612 14.1588 26.1289 14.5283 26.4698C14.8978 26.8108 15.3822 27.0001 15.885 27H22.115C22.6178 27.0001 23.1022 26.8108 23.4717 26.4698C23.8412 26.1289 24.0688 25.6612 24.109 25.16L24.962 14.5H25.5C25.6326 14.5 25.7598 14.4473 25.8536 14.3536C25.9473 14.2598 26 14.1326 26 14C26 13.8674 25.9473 13.7402 25.8536 13.6464C25.7598 13.5527 25.6326 13.5 25.5 13.5H24.505C24.5017 13.5 24.4983 13.5 24.495 13.5H22ZM23.958 14.5L23.112 25.08C23.0919 25.3306 22.9781 25.5644 22.7934 25.7349C22.6086 25.9054 22.3664 26.0001 22.115 26H15.885C15.6336 26.0001 15.3914 25.9054 15.2066 25.7349C15.0219 25.5644 14.9081 25.3306 14.888 25.08L14.042 14.5H23.958ZM16.471 15.5C16.6033 15.4924 16.7333 15.5376 16.8323 15.6257C16.9313 15.7138 16.9913 15.8377 16.999 15.97L17.499 24.47C17.5043 24.6008 17.458 24.7284 17.3702 24.8255C17.2824 24.9225 17.1601 24.9813 17.0294 24.9892C16.8988 24.997 16.7702 24.9533 16.6714 24.8675C16.5726 24.7816 16.5115 24.6605 16.501 24.53L16 16.03C15.9959 15.9643 16.0049 15.8985 16.0263 15.8362C16.0478 15.774 16.0813 15.7167 16.125 15.6674C16.1686 15.6182 16.2216 15.578 16.2808 15.5493C16.34 15.5206 16.4043 15.5038 16.47 15.5H16.471ZM21.529 15.5C21.5947 15.5038 21.659 15.5206 21.7182 15.5493C21.7774 15.578 21.8304 15.6182 21.874 15.6674C21.9177 15.7167 21.9512 15.774 21.9727 15.8362C21.9941 15.8985 22.0031 15.9643 21.999 16.03L21.499 24.53C21.4963 24.5964 21.4804 24.6617 21.4522 24.7219C21.424 24.7821 21.3841 24.8361 21.3348 24.8807C21.2855 24.9254 21.2278 24.9597 21.165 24.9817C21.1023 25.0037 21.0358 25.013 20.9694 25.009C20.903 25.005 20.8381 24.9878 20.7785 24.9585C20.7188 24.9291 20.6656 24.8881 20.622 24.8379C20.5784 24.7877 20.5452 24.7293 20.5244 24.6661C20.5037 24.603 20.4957 24.5363 20.501 24.47L21.001 15.97C21.0087 15.8377 21.0687 15.7138 21.1677 15.6257C21.2667 15.5376 21.3967 15.4924 21.529 15.5ZM19 15.5C19.1326 15.5 19.2598 15.5527 19.3536 15.6464C19.4473 15.7402 19.5 15.8674 19.5 16V24.5C19.5 24.6326 19.4473 24.7598 19.3536 24.8536C19.2598 24.9473 19.1326 25 19 25C18.8674 25 18.7402 24.9473 18.6464 24.8536C18.5527 24.7598 18.5 24.6326 18.5 24.5V16C18.5 15.8674 18.5527 15.7402 18.6464 15.6464C18.7402 15.5527 18.8674 15.5 19 15.5Z"
                fill={ThemeConstants.ICON_COLOR}
            />
        </g>
    </svg>
);
export const EnableDeleteIcon: React.FC<IconImageProps> = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
        <rect x="0.5" y="0.5" width="37" height="37" rx="1.5" fill="white" fillOpacity="0.01" />
        <rect x="0.5" y="0.5" width="37" height="37" rx="1.5" stroke="#6B7075" />
        <path
            d="M17.5 12H20.5C20.6326 12 20.7598 12.0527 20.8536 12.1464C20.9473 12.2402 21 12.3674 21 12.5V13.5H17V12.5C17 12.3674 17.0527 12.2402 17.1464 12.1464C17.2402 12.0527 17.3674 12 17.5 12V12ZM22 13.5V12.5C22 12.1022 21.842 11.7206 21.5607 11.4393C21.2794 11.158 20.8978 11 20.5 11H17.5C17.1022 11 16.7206 11.158 16.4393 11.4393C16.158 11.7206 16 12.1022 16 12.5V13.5H13.506C13.5027 13.5 13.4993 13.5 13.496 13.5H12.5C12.3674 13.5 12.2402 13.5527 12.1464 13.6464C12.0527 13.7402 12 13.8674 12 14C12 14.1326 12.0527 14.2598 12.1464 14.3536C12.2402 14.4473 12.3674 14.5 12.5 14.5H13.038L13.891 25.16C13.9312 25.6612 14.1588 26.1289 14.5283 26.4698C14.8978 26.8108 15.3822 27.0001 15.885 27H22.115C22.6178 27.0001 23.1022 26.8108 23.4717 26.4698C23.8412 26.1289 24.0688 25.6612 24.109 25.16L24.962 14.5H25.5C25.6326 14.5 25.7598 14.4473 25.8536 14.3536C25.9473 14.2598 26 14.1326 26 14C26 13.8674 25.9473 13.7402 25.8536 13.6464C25.7598 13.5527 25.6326 13.5 25.5 13.5H24.505C24.5017 13.5 24.4983 13.5 24.495 13.5H22ZM23.958 14.5L23.112 25.08C23.0919 25.3306 22.9781 25.5644 22.7934 25.7349C22.6086 25.9054 22.3664 26.0001 22.115 26H15.885C15.6336 26.0001 15.3914 25.9054 15.2066 25.7349C15.0219 25.5644 14.9081 25.3306 14.888 25.08L14.042 14.5H23.958ZM16.471 15.5C16.6033 15.4924 16.7333 15.5376 16.8323 15.6257C16.9313 15.7138 16.9913 15.8377 16.999 15.97L17.499 24.47C17.5043 24.6008 17.458 24.7284 17.3702 24.8255C17.2824 24.9225 17.1601 24.9813 17.0294 24.9892C16.8988 24.997 16.7702 24.9533 16.6714 24.8675C16.5726 24.7816 16.5115 24.6605 16.501 24.53L16 16.03C15.9959 15.9643 16.0049 15.8985 16.0263 15.8362C16.0478 15.774 16.0813 15.7167 16.125 15.6674C16.1686 15.6182 16.2216 15.578 16.2808 15.5493C16.34 15.5206 16.4043 15.5038 16.47 15.5H16.471ZM21.529 15.5C21.5947 15.5038 21.659 15.5206 21.7182 15.5493C21.7774 15.578 21.8304 15.6182 21.874 15.6674C21.9177 15.7167 21.9512 15.774 21.9727 15.8362C21.9941 15.8985 22.0031 15.9643 21.999 16.03L21.499 24.53C21.4963 24.5964 21.4804 24.6617 21.4522 24.7219C21.424 24.7821 21.3841 24.8361 21.3348 24.8807C21.2855 24.9254 21.2278 24.9597 21.165 24.9817C21.1023 25.0037 21.0358 25.013 20.9694 25.009C20.903 25.005 20.8381 24.9878 20.7785 24.9585C20.7188 24.9291 20.6656 24.8881 20.622 24.8379C20.5784 24.7877 20.5452 24.7293 20.5244 24.6661C20.5037 24.603 20.4957 24.5363 20.501 24.47L21.001 15.97C21.0087 15.8377 21.0687 15.7138 21.1677 15.6257C21.2667 15.5376 21.3967 15.4924 21.529 15.5V15.5ZM19 15.5C19.1326 15.5 19.2598 15.5527 19.3536 15.6464C19.4473 15.7402 19.5 15.8674 19.5 16V24.5C19.5 24.6326 19.4473 24.7598 19.3536 24.8536C19.2598 24.9473 19.1326 25 19 25C18.8674 25 18.7402 24.9473 18.6464 24.8536C18.5527 24.7598 18.5 24.6326 18.5 24.5V16C18.5 15.8674 18.5527 15.7402 18.6464 15.6464C18.7402 15.5527 18.8674 15.5 19 15.5V15.5Z"
            fill={ThemeConstants.ICON_COLOR}
        />
    </svg>
);

export const AddIcon: React.FC<IconImageProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 17">
        <g>
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                fillRule="evenodd"
                d="M8 2.5a.5.5 0 01.5.5v5h5a.5.5 0 010 1h-5v5a.5.5 0 11-1 0V9h-5a.5.5 0 010-1h5V3a.5.5 0 01.5-.5z"
                clipRule="evenodd"
            ></path>
        </g>
    </svg>
);
export const SavedMessageEditIcon: React.FC<IconImageProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 17 17">
        <g clipPath="url(#clip0_5792_407)">
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                d="M12.646.645a.5.5 0 01.708 0l3 3a.501.501 0 010 .708l-10 10a.5.5 0 01-.168.11l-5 2a.5.5 0 01-.65-.65l2-5a.5.5 0 01.11-.168l10-10zM11.706 3L14 5.292 15.293 4 13 1.706 11.707 3zm1.587 3L11 3.706l-6.5 6.5v.293H5a.5.5 0 01.5.5v.5H6a.5.5 0 01.5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.82-1.528.107-.106A.5.5 0 015.5 13v-.5H5a.5.5 0 01-.5-.5v-.5H4a.5.5 0 01-.468-.325z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_5792_407">
                <path fill="#fff" d="M0 0H16V16H0z" transform="translate(.5 .5)"></path>
            </clipPath>
        </defs>
    </svg>
);
export const SavedMessageDeleteIcon: React.FC<IconImageProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="0 0 16 17">
        <g clipPath="url(#clip0_5792_436)">
            <path
                fill={props?.color ?? ThemeConstants.ICON_COLOR}
                d="M6.5 1.5h3a.5.5 0 01.5.5v1H6V2a.5.5 0 01.5-.5zM11 3V2A1.5 1.5 0 009.5.5h-3A1.5 1.5 0 005 2v1H1.5a.5.5 0 000 1h.538l.853 10.66a2 2 0 001.994 1.84h6.23a2 2 0 001.994-1.84L13.962 4h.538a.5.5 0 000-1H11zm1.958 1l-.846 10.58a1 1 0 01-.997.92h-6.23a1 1 0 01-.997-.92L3.042 4h9.916zM5.47 5a.5.5 0 01.528.47l.5 8.5a.5.5 0 01-.998.06L5 5.53A.5.5 0 015.47 5zm5.058 0a.5.5 0 01.47.53l-.5 8.5a.499.499 0 01-.877.307.5.5 0 01-.121-.368l.5-8.5a.5.5 0 01.528-.47zm-2.53 0a.5.5 0 01.5.5V14a.5.5 0 11-1 0V5.5A.5.5 0 018 5z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_5792_436">
                <path fill="#fff" d="M0 0H16V16H0z" transform="translate(0 .5)"></path>
            </clipPath>
        </defs>
    </svg>
);

export const VerticalEllipsisIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width={props.width || 24}
            height={props.height || 24}
        >
            <path d="M12 16a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2 2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2Z" />
        </svg>
    );
};


export const ShieldIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 297.891 297.891"
            width={props.width || 24}
            height={props.height || 24}
            xmlSpace="preserve"
            {...props}
        >
            <path
                fill={props.color || "#ffffffce"}
                d="M264.148 40.644 153.978.89a14.838 14.838 0 0 0-5.061-.89c-1.731 0-3.449.3-5.101.899L34.041 40.653c-5.933 2.152-10.096 7.789-10.096 14.101v94.191c0 21.029 6.778 42.061 19.713 62.51 9.915 15.673 23.715 31.043 40.802 45.686 28.57 24.482 56.918 38.604 58.109 39.193a15.115 15.115 0 0 0 6.681 1.557c2.245 0 4.505-.504 6.577-1.512 1.191-.58 29.526-14.482 58.123-38.867 17.104-14.584 30.697-29.954 40.619-45.682 12.93-20.493 19.375-41.65 19.375-62.885V54.754c.001-6.322-3.849-11.966-9.796-14.11zM47.945 148.875V65.969c0-3.156 1.934-5.975 4.901-7.051l93.312-33.947c.832-.301 1.787-.523 2.787-.523v124.498h101.711c.006 0 .013.135.013.221-.02 27.129-13.684 54.016-40.607 80.195-21.025 20.445-44.912 35.036-57.199 41.919-1.139.639-2.917.94-3.917.94V148.907l-101.001-.032z"
            />
        </svg>
    );
};

export const HamburgerIcon: React.FC<IconImageProps> = () => {
    return (
        <svg width="24" height="20" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path
                stroke="null"
                fill="#88C656"
                id="a"
                d="m1.96678,0.64707l20.06702,0a1.67225,1.87059 0 0 1 0,3.74117l-20.06702,0a1.67225,1.87059 0 1 1 0,-3.74117zm0,7.48234l20.06702,0a1.67225,1.87059 0 0 1 0,3.74117l-20.06702,0a1.67225,1.87059 0 1 1 0,-3.74117zm0,7.48234l20.06702,0a1.67225,1.87059 0 0 1 0,3.74117l-20.06702,0a1.67225,1.87059 0 0 1 0,-3.74117z"
            />
        </svg>
    );
};

export const ViewInboxIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width={props.width}
        height={props.height}
        fill={props.color ?? ThemeConstants.ICON_COLOR}
    >
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    </svg>
);

export const WarningIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            width={props?.width ?? 16}
            height={props?.height ?? 16}
            viewBox="0 0 16 15" fill={props?.color ?? "currentColor"} xmlns="http://www.w3.org/2000/svg" >
            <path d="M8.98201 1.56601C8.88302 1.39358 8.74028 1.25031 8.56821 1.15069C8.39614 1.05106 8.20084 0.998596 8.00201 0.998596C7.80318 0.998596 7.60787 1.05106 7.4358 1.15069C7.26373 1.25031 7.121 1.39358 7.02201 1.56601L0.165007 13.233C-0.291993 14.011 0.256007 15 1.14501 15H14.858C15.747 15 16.296 14.01 15.838 13.233L8.98201 1.56601ZM8.00001 5.00001C8.53501 5.00001 8.95401 5.46201 8.90001 5.99501L8.55001 9.50201C8.53825 9.63978 8.47521 9.76813 8.37336 9.86165C8.27152 9.95517 8.13828 10.0071 8.00001 10.0071C7.86173 10.0071 7.7285 9.95517 7.62665 9.86165C7.52481 9.76813 7.46177 9.63978 7.45001 9.50201L7.10001 5.99501C7.08744 5.86925 7.10135 5.74224 7.14085 5.62218C7.18035 5.50212 7.24456 5.39166 7.32935 5.29792C7.41414 5.20419 7.51762 5.12925 7.63313 5.07794C7.74864 5.02663 7.87361 5.00008 8.00001 5.00001ZM8.00201 11C8.26722 11 8.52158 11.1054 8.70911 11.2929C8.89665 11.4804 9.00201 11.7348 9.00201 12C9.00201 12.2652 8.89665 12.5196 8.70911 12.7071C8.52158 12.8947 8.26722 13 8.00201 13C7.73679 13 7.48244 12.8947 7.2949 12.7071C7.10736 12.5196 7.00201 12.2652 7.00201 12C7.00201 11.7348 7.10736 11.4804 7.2949 11.2929C7.48244 11.1054 7.73679 11 8.00201 11Z" />
        </svg>
    );
};

export const ChevronRightIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={props.width ?? 16}
            height={props.height ?? 16}
            fill='none'
            viewBox='0 0 16 16'
        >
            <path
                fill={props?.color ?? "#000"}
                fillRule='evenodd'
                d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'
                clipRule='evenodd'
            ></path>
        </svg>
    );
};

export const ChevronDownIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? "16"}
            height={props.height ?? "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color ?? "#000"}
                fillRule="evenodd"
                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const SlantedPaperClipIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? "16"}
            height={props.height ?? "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props?.color ?? "#05386B"}
                d="M8.953 2.747a2.188 2.188 0 0 1 3.094 3.094l-5.569 5.568a1.312 1.312 0 1 1-1.856-1.856l4.331-4.331a.438.438 0 1 1 .619.619L5.24 10.17a.438.438 0 0 0 .619.62l5.568-5.57a1.313 1.313 0 0 0-1.856-1.855L4.003 8.934a2.187 2.187 0 1 0 3.094 3.094l4.331-4.331a.437.437 0 1 1 .619.618l-4.331 4.332a3.063 3.063 0 0 1-4.331-4.332z"
            ></path>
        </svg>
    );
};

export const QuickReplyIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props?.width ?? "18"}
            height={props?.height ?? "18"}
            fill="none"
            viewBox="0 0 18 17"
        >
            <path
                stroke="#05386B"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14 9 3 2-3 2"
            ></path>
            <path
                stroke="#05386B"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16 11h-2.579c-1.172 0-2.297.395-3.126 1.098C9.465 12.802 9 13.755 9 14.75V16M10 10.333H6.333L3.667 13v-2.667h-2A.667.667 0 0 1 1 9.667v-8A.667.667 0 0 1 1.667 1h12.666a.667.667 0 0 1 .667.667v6"
            ></path>
        </svg>
    );
};

export const NotificationBellIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            width={props?.width || "16"}
            height={props?.height || "16"}
            viewBox="0 0 14 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7 16C8.10457 16 9 15.1046 9 14H5C5 15.1046 5.89543 16 7 16Z"
                fill={props?.color || ThemeConstants.ICON_COLOR}
            />
            <path
                d="M7 1.91825L6.20281 2.07925C4.37552 2.44829 3.00002 4.06463 3.00002 6C3.00002 6.62782 2.86566 8.19725 2.54116 9.74216C2.38006 10.5091 2.16454 11.3076 1.87809 12H12.1219C11.8355 11.3076 11.62 10.5091 11.4589 9.74216C11.1344 8.19724 11 6.62782 11 6C11 4.06462 9.6245 2.44827 7.7972 2.07924L7 1.91825ZM13.2193 12C13.4426 12.4474 13.7015 12.801 14 13H0C0.298527 12.801 0.557447 12.4474 0.7807 12C1.67922 10.1994 2.00002 6.87916 2.00002 6C2.00002 3.57934 3.7202 1.56045 6.00484 1.09904C6.00164 1.06646 6 1.03342 6 1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1C8 1.03342 7.99836 1.06646 7.99516 1.09903C10.2798 1.56042 12 3.57932 12 6C12 6.87916 12.3208 10.1994 13.2193 12Z"
                fill={props?.color || ThemeConstants.ICON_COLOR}
            />
        </svg>
    );
};

export const DisabledNotificationBellIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            width={props?.width || "17"}
            height={props?.height || "17"}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.16427 14.0001H15.0002C14.7017 13.801 14.4428 13.4475 14.2195 13.0001C13.321 11.1994 13.0003 7.87922 13.0003 7.00005C13.0003 6.73607 12.9798 6.47686 12.9404 6.22394L12.0027 7.16164C12.0221 7.86976 12.1596 9.31642 12.4591 10.7422C12.6202 11.5091 12.8357 12.3077 13.1222 13.0001H6.16427L5.16427 14.0001Z"
                fill={props?.color || ThemeConstants.ICON_COLOR}
            />
            <path
                d="M10.7454 4.09052C10.213 3.58791 9.54283 3.22983 8.79745 3.0793L8.00025 2.9183L7.20305 3.0793C5.37577 3.44834 4.00027 5.06468 4.00027 7.00005C4.00027 7.62788 3.8659 9.1973 3.5414 10.7422C3.49146 10.98 3.43629 11.2208 3.37539 11.4605L1.72256 13.1133C1.74229 13.0763 1.76175 13.0385 1.78094 13.0001C2.67947 11.1994 3.00027 7.87922 3.00027 7.00005C3.00027 4.57939 4.72044 2.5605 7.00509 2.0991C7.00188 2.06652 7.00024 2.03348 7.00024 2.00005C7.00024 1.44777 7.44796 1.00005 8.00024 1.00005C8.55253 1.00005 9.00024 1.44777 9.00024 2.00005C9.00024 2.03347 8.9986 2.06651 8.9954 2.09909C9.93746 2.28934 10.7836 2.7444 11.4526 3.38326L10.7454 4.09052Z"
                fill="#05386B"
            />
            <path
                d="M10.0002 15.0001C10.0002 16.1046 9.10481 17.0001 8.00024 17.0001C6.89567 17.0001 6.00024 16.1046 6.00024 15.0001H10.0002Z"
                fill={props?.color || ThemeConstants.ICON_COLOR}
            />
            <path
                d="M0.625056 15.6251C0.41795 15.8322 0.41795 16.1679 0.625056 16.3751C0.832163 16.5822 1.16795 16.5822 1.37505 16.3751L16.1251 1.62506C16.3322 1.41795 16.3322 1.08216 16.1251 0.875057C15.918 0.66795 15.5822 0.66795 15.3751 0.875057L0.625056 15.6251Z"
                fill={props?.color || ThemeConstants.ICON_COLOR}
            />
        </svg>
    );
};